import Immutable from 'immutable'

type PartialState = {
  menuRecipes: Immutable.List<any>
}

export const getNumMenuRecipes = (state: PartialState) => state.menuRecipes.count()
